import React from "react";
import Welcome from "../../Welcome";

const Screen14 = () => {
    return <Welcome />;
};

export default Screen14;
